import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans kyc dont les clés ne sont pas encore fusionnées
 * dans `src/locales/*.json` (fragments `features/kyc/i18n/*.json` — fusion
 * par le coordinateur). Les clés déjà fusionnées passent par
 * `useTypedTranslation` directement ; celles des fragments exigent ce cast.
 */
export const useKycTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
